// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: wh4j1QDwJ4

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicButtonLinkSecondary.module.css"; // plasmic-import: wh4j1QDwJ4/css

createPlasmicElementProxy;

export type PlasmicButtonLinkSecondary__VariantMembers = {};
export type PlasmicButtonLinkSecondary__VariantsArgs = {};
type VariantPropType = keyof PlasmicButtonLinkSecondary__VariantsArgs;
export const PlasmicButtonLinkSecondary__VariantProps =
  new Array<VariantPropType>();

export type PlasmicButtonLinkSecondary__ArgsType = {
  text?: React.ReactNode;
};
type ArgPropType = keyof PlasmicButtonLinkSecondary__ArgsType;
export const PlasmicButtonLinkSecondary__ArgProps = new Array<ArgPropType>(
  "text"
);

export type PlasmicButtonLinkSecondary__OverridesType = {
  buttonLinkSecondary?: p.Flex<"a">;
};

export interface DefaultButtonLinkSecondaryProps {
  text?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicButtonLinkSecondary__RenderFunc(props: {
  variants: PlasmicButtonLinkSecondary__VariantsArgs;
  args: PlasmicButtonLinkSecondary__ArgsType;
  overrides: PlasmicButtonLinkSecondary__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <p.Stack
      as={"a"}
      data-plasmic-name={"buttonLinkSecondary"}
      data-plasmic-override={overrides.buttonLinkSecondary}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.buttonLinkSecondary
      )}
    >
      {p.renderPlasmicSlot({
        defaultContents: (
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__p3WcV
            )}
          >
            {"Design"}
          </div>
        ),
        value: args.text,
        className: classNames(sty.slotTargetText)
      })}
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  buttonLinkSecondary: ["buttonLinkSecondary"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  buttonLinkSecondary: "a";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicButtonLinkSecondary__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicButtonLinkSecondary__VariantsArgs;
    args?: PlasmicButtonLinkSecondary__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicButtonLinkSecondary__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicButtonLinkSecondary__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicButtonLinkSecondary__ArgProps,
          internalVariantPropNames: PlasmicButtonLinkSecondary__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonLinkSecondary__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "buttonLinkSecondary") {
    func.displayName = "PlasmicButtonLinkSecondary";
  } else {
    func.displayName = `PlasmicButtonLinkSecondary.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonLinkSecondary = Object.assign(
  // Top-level PlasmicButtonLinkSecondary renders the root element
  makeNodeComponent("buttonLinkSecondary"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicButtonLinkSecondary
    internalVariantProps: PlasmicButtonLinkSecondary__VariantProps,
    internalArgProps: PlasmicButtonLinkSecondary__ArgProps
  }
);

export default PlasmicButtonLinkSecondary;
/* prettier-ignore-end */
